export const PageUrlUa = {
  campaign: {
    list: {
      url: "/campaign/campaignmanagement",
    },
    save: {
      url: "/campaign/campaignmanagement/save/:id?",
    },
    matrix : {
      url : "/campaign/campaignmanagement/matrix/"
    }
  },
};
